import {DomainObject} from 'shared/store';
import {computed, observable} from 'mobx';
import {t} from 'shared/core';

class PublicInterviewSchedule extends DomainObject {
  @observable calendarEventName;
  @observable duration;
  @observable location;
  @observable address;
  @observable phoneNumber;
  @observable eventDescription;
  @observable videoConferencingProvider;
  @observable interviewers;

  @computed get locationView() {
    if (this.videoConferencingProvider) {
      return t(`recruiting.schedule_interview.location.video_conferencing_provider.${this.videoConferencingProvider}`);
    }

    return t(`recruiting.schedule_interview.location.${this.location}`);
  }
}

export default PublicInterviewSchedule;
